module.exports = __webpack_public_path__ + "img/pickFour_g.cbe0909e.png";